var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"PAGE_UP","name":"PAGE_UP","data-vcode":"PAGE_UP"}},[_c('img',{attrs:{"src":"/images/icons/pageUp.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('pageUp')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }